import { render, staticRenderFns } from "./WaitingListMobileItem.vue?vue&type=template&id=48eceef8"
import script from "./WaitingListMobileItem.vue?vue&type=script&lang=js"
export * from "./WaitingListMobileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports